/** Created by azhou on 2019/3/11.*/
<template>
    <div>
      <public-title>资金明细
        <span class="text-link ml-auto" slot="right" @click="$router.back()" v-show="isGroup">返回列表</span>
      </public-title>
      <total-list-head />
      <!--菜单栏、搜索栏-->
      <div class="bg-white text-right pt-2 pr-3 text-warning" v-show="activeName == 'all' && storeInfo.type != 2">实收金额总计:&yen;{{(Number(StoreMoneyList.money) / 100).toFixed(2)}}</div>
      <div class="bg-white text-right pt-2 pr-3 text-warning" v-show="activeName == 'all' && storeInfo.type == 2">实付金额总计:&yen;{{(Number(StoreMoneyList.pay) / 100).toFixed(2)}}</div>
      <div class="d-center-between bg-white pl-3 pr-3">
        <el-menu mode="horizontal" @select="handleSelect" :default-active="activeName">
          <el-menu-item index="all">资金明细</el-menu-item>
          <el-menu-item index="rebate" v-if="userInfo.type===2">平台返点</el-menu-item>
          <el-submenu index="withdraw">
            <template slot="title">{{withdrawTitle}}</template>
            <el-menu-item :index="item.value" :key="item.value"
              v-for="item in withdrawMenuArr">
              {{item.name}}
              <el-tooltip class="item" effect="dark" content="平台打款处理中" placement="right" v-show="item.name == '冻结中'">
                <i class="el-icon-info text-info ml-1" />
              </el-tooltip>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="invoice" v-show="userInfo.type!==2">
            <template slot="title">{{invoiceTitle}}</template>
            <el-menu-item :index="item.value" :key="item.value"
                v-for="item in invoiceMenuArr">{{item.name}}</el-menu-item>
          </el-submenu>
        </el-menu>
        <div class="mt-3 text-right p-2 w-45" v-show="$GFUN.isInArray(['all','Freezing','WithdrawDone'],activeName)">
          <el-select v-model="searchType" placeholder="请选择搜索条件" class="mr-2" size="small" style="width:130px">
            <el-option v-for="item in searchTypes" :key="item.name" :value="item.type" :label="item.name"/>
          </el-select>
          <el-select v-model="storeType" placeholder="请选择门店类型" class="w-20 mr-2" size="small" v-show="searchType === 'storeName'">
            <el-option v-for="item in $GVAR.StoreType.slice(1,6)" :key="item.name" :value="item.id" :label="item.name"/>
          </el-select>
          <el-input class="w-30 mr-2" v-model="searchText" size="small" placeholder="请输入搜索内容" v-show="searchType && searchType !== 'time' && searchType !== 'checkinout'"/>
          <el-date-picker class="w-50" v-model="timestamp" size="small" type="daterange"  v-show="searchType === 'time' || searchType === 'checkinout'"
                          value-format="timestamp" start-placeholder="开始时间" end-placeholder="结束时间" />
          <el-button class="ml-2" type="primary" @click="getLists('search')" size="small">搜索</el-button>
        </div>
        <div class="mt-3">
          <el-button type="primary" size="small" v-show="activeName == 'WithdrawDone'" plain @click="payMerge=!payMerge;getLists('search')">{{payMerge ? '取消合并' : '打款合并'}}</el-button>
          <el-button size="small" type="danger" @click="ComMsg">{{btnmsg}}</el-button>
          <el-button class="ml-2" size="small" type="success" @click="applyCtrol" v-show="showCtrolBtn">{{ctrolBtnText.btn}}</el-button>
          <!-- <el-button class="ml-2" size="small" type="success" @click="applyAllCtrol" v-show="showCtrolBtn">{{ctrolBtnText.allbtn}}</el-button> -->
        </div>
      </div>
      <!--列表结果项-->
      <div class="bg-white pt-4 pl-3 pr-3 pb-4 blank_space">
        <p v-if="StoreMoneyList.total<=0">未查询到数据</p>
        <div v-else>
          <ul class="list-head mt-3">
            <li v-if="activeName === 'allowWithdraw'"><el-checkbox v-model="allChecked" class="mt-1" @change="setAllChecked" /></li>
            <li :class="item.w || 'w-50'" v-for="item in titleArr" :key="item.label">{{item.label || item}}</li>
          </ul>
          <!--资金明细-->
          <div v-if="activeName === 'all'">
            <itemize-money v-for="item in StoreMoneyList.lists" :key="item.id" :Itemize="item" :search="searchType" />
          </div>
          <!--采购商返点明细-->
          <div v-if="activeName === 'rebate'">
            <itemize-rebate v-for="item in StoreMoneyList.lists" :key="item.id" :Itemize="item"/>
          </div>
          <!--可提现列表-->
          <div v-if="activeName === 'allowWithdraw'">
            <itemize-withdraw-operate v-for="item in StoreMoneyList.lists" :key="item.id" :Itemize="item"/>
          </div>
          <!--已提现明细、冻结金额-->
          <div v-if="$GFUN.isInArray(['WithdrawDone','Freezing'],activeName)">
            <div v-if="payMerge && activeName == 'WithdrawDone'">
              <itemize-merge-already v-for="item in StoreMoneyList.lists" :key="item.id" :Itemize="item" />
            </div>
            <div v-else>
              <itemize-already-withdraw  v-for="item in StoreMoneyList.lists" :key="item.id" :Itemize="item"/>
            </div>
          </div>
          <!--发票申请-->
          <div v-if="$GFUN.isInArray(['allowInvoice','verifyInvoice','InvoiceDone'],activeName)">
            <itemize-invoice v-for="item in StoreMoneyList.lists" :key="item.id" :Itemize="item"/>
          </div>

          <el-pagination background layout="prev, pager, next" class="mt-4" v-show="showTenNum"
                         :total="StoreMoneyList.total" :current-page="Number(queryCon.page)"
                         @current-change="v => this.currentPage=v"/>
        </div>
      </div>
      <!--提现选择银行卡/开票选择开票信息-->
      <el-dialog :visible.sync="beginCtrol" center :title="ctrolBtnText.btn">
        <div class="d-start-center">
          <left-text :leftText="ctrolBtnText.cbi"/>
          <div class="w-90">
            <div class="single-choose mb-2 w-90" v-for="item in ctrolBtnText.backups" :key="item .id"
               @click="chooseBackup = item.id" :class="{'active':chooseBackup === item.id || ctrolBtnText.backups.length == 1, 'defaultbg': item.is_default == 1 && !chooseBackup}">
              <p class="d-center-between w-100" v-if="activeName==='allowWithdraw'">
                {{item.bank}}&nbsp;( {{item.truename}} )<span><label v-if="item.is_default == 1" class="text-muted mr-2">(默认)</label>尾号：{{item.card.substr(item.card.length - 4)}}</span>
              </p>
              <p class="d-center-between w-100" v-if="activeName==='allowInvoice'">
                <el-row v-if="item.rise">
                  <el-col :span="12">发票类型：普通</el-col>
                  <el-col :span="12">抬头：{{item.rise}}</el-col>
                  <el-col :span="12">税号：{{item.duty_paragraph}}</el-col>
                  <el-col :span="12">收件人：{{item.addressee}}</el-col>
                  <el-col :span="12">联系方式： {{item.mobile}}</el-col>
                  <el-col :span="24">收件地址：{{item.receiving_address}}</el-col>
                </el-row>
                <el-row v-else>
                  <el-col :span="12">发票类型：专票</el-col>
                  <el-col :span="12">公司名称：{{item.corporate_name}}</el-col>
                  <el-col :span="12">税号：{{item.duty_paragraph}}</el-col>
                  <el-col :span="12">发票公司地址：{{item.address}}</el-col>
                  <el-col :span="12">公司电话：{{item.corporate_mobile}}</el-col>
                  <el-col :span="12">开户行名称： {{item.opening_bank}}</el-col>
                  <el-col :span="12">开户账号：{{item.account_number}}</el-col>
                  <el-col :span="12">收件人：{{item.addressee}}</el-col>
                  <el-col :span="12">联系方式：{{item.mobile}}</el-col>
                  <el-col :span="12">收件地址：{{item.receiving_address}}</el-col>
                </el-row>
              </p>
            </div>
            <p class="single-choose w-90" @click="addNewBackup">
              <span class="iconfont mr-3 icon-jia h6">去添加新项</span>
            </p>
          </div>
        </div>
        <p class="text-center mt-4" v-show="activeName==='allowWithdraw'">
          申请提现金额：&yen;{{totalWithdraw | formatMoney}}元
          <span class="ml-4">实际到账金额：&yen;{{finalWithdraw | formatMoney}}元</span>
        </p>
        <span slot="footer">
          <el-button @click="cancelCtrol">取 消</el-button>
          <el-button type="primary" @click="ensureCtrol">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
  import { mapGetters,mapState, mapActions,mapMutations } from 'vuex'
  import ItemizeMoney from './ItemizeMoney'
  import ItemizeWithdrawOperate from './ItemizeWithdrawOperate'
  import ItemizeAlreadyWithdraw from './ItemizeAlreadyWithdraw'
  import ItemizeInvoice from './ItemizeInvoice'
  import TotalListHead from './TotalListHead'
  import ItemizeRebate from './ItemizeRebate'
  import ItemizeMergeAlready from './ItemizeMergeAlready'

  export default {
    name: 'TotalLists',
    components: { ItemizeRebate, TotalListHead, ItemizeMoney,ItemizeWithdrawOperate,ItemizeAlreadyWithdraw,ItemizeInvoice,ItemizeMergeAlready },
    computed: {
      ...mapState(['StoreMoneyInfo','StoreMoneyList','StoreBankcardList','StoreInvoiceLists']),
      ...mapGetters(['storeInfo','isGroup','userInfo']),
      //使用路由来记录的页数
      queryCon() { return this.$route.query },
      //选择条件备选项
      searchTypes() {
        switch (this.storeInfo.type) {
          case 2:
            if (this.activeName === 'all') return [{type:'orderNum',name:'订单号'},{type:'storeName',name:'门店名称'}, {type:'tradeNum',name:'支付平台流水号'}, {type:'time',name:'支付时间'}];
            else return [{type:'orderNum',name:'订单号'},{type:'time',name:`提现时间`}];
          default:return [{type:'orderNum',name:'订单号'},{type:'time',name:`${this.activeName === 'all' ? '支付' : '提现'}时间`},{type:'checkinout',name:`入住日期`}];
        }
      },
      //搜索条件-开始时间
      startTime() { return this.timestamp ? this.timestamp[0] / 1000 : ''; },
      //搜索条件-结束时间
      endTime() { return this.timestamp ? this.timestamp[1] / 1000 + 86399 : ''; },
      //申请提现总额
      totalWithdraw() {
        if (this.activeName !== 'allowWithdraw') return 0;
        let list = this.StoreMoneyList.lists.filter(v => v.checked);
        let total = 0;
        if (this.userInfo.type !== 2) list.forEach(v => total += Number(v.in_withdraw_money.replace(',','')));
        else list.forEach(v => total += (Number(v.availableMoney) / 100));
        return total;
      },
      //实际到账金额
      finalWithdraw() {
        if (this.activeName !== 'allowWithdraw') return 0;
        if (this.userInfo.type === 2) return this.totalWithdraw;
        let list = this.StoreMoneyList.lists.filter(v => v.checked);
        let total = 0;
        list.forEach(v => {
          let valued = Number(v.in_withdraw_money.replace(',',''));   //可提金额
          let commision = Number(v.commision_price.replace(',',''));  //佣金
          total += (valued - commision);
        });
        return total;
      },
      //列表展示项数组
      titleArr() {
        switch (this.activeName) {
          case 'all':
            switch (this.storeInfo.type) {
              case 2:
                return [
                  {label:'门店名称/订单号',w:'w-30'},{label:'门店类型',w:'w-10'},{label:'资金类型',w:'w-15'},{label:'支付金额',w:'w-20'},
                  {label:'支付方式',w:'w-10'},{label:'支付时间',w:'w-15'},{label:'支付平台流水号',w:'w-30'},{label:'备注',w:'w-10'},
                ];
              default:
                return [
                  {label:'金额类型',w:'w-30'},{label:'金额',w:'w-20'},{label:'支付时间',w:'w-15'},{label:'支付平台流水号',w:'w-30'},{label:'备注',w:'w-10'},
                ];
            }
          case 'rebate':
            return [{label:'类型',w:'w-15'},{label:'支付金额',w:'w-20'},{label:'返点金额',w:'w-15'},{label:'支付时间/订单号',w:'w-40'},{label:'交易流水号',w:'w-30'},{label:'备注',w:'w-10'},];
          case 'allowWithdraw':
            switch (this.storeInfo.type) {
              case 8:
              case 6:return [
                {label:'预订单位/出行日期/订单号',w:'w-100'},{label:'总金额',w:'w-50'},{label:'已提金额',w:'w-50'},{label:'冻结金额',w:'w-50'},{label:'可提金额',w:'w-50'},{label:'不可提金额',w:'w-50'},{label:'佣金',w:'w-50'}
                ];
              case 5:return [
                {label:'预订单位/入住日期/订单号',w:'w-100'},{label:'订单总额',w:'w-50'},{label:'已付总额',w:'w-50'},{label:'已提金额',w: 'w-50'},{label:'冻结金额',w:'w-50'},{label:'可提金额',w:'w-50'},{label:'不可提金额',w:'w-50'},{label:'佣金',w:'w-50'}
                ];
              case 3:return ['预订单位/团号','订单总额','已付总额','已提金额','冻结金额','可提金额','不可提金额','佣金'];
              case 2:return ['门店名称/订单号','付款金额','付款时间','返点金额','可提金额'];
              default:return [];
            }
          case 'Freezing':
          case 'WithdrawDone':
            if (this.payMerge) return [{label:'打款时间',w:'w-30'},{label:'收款方',w:'w-20'},{label:'申请金额',w:'w-20'},{label:'实际打款',w:'w-20'},{label:'操作',w:'w-10'}];
            else return [{label:'创建时间/订单号',w:'w-30'},{label:'收款方',w:'w-20'},{label:'申请金额',w:'w-15'},{label:'实际打款',w:'w-15'},{label:'状态',w:'w-10'},{label:'操作',w:'w-10'}];
          case 'allowInvoice':
          case 'verifyInvoice':
          case 'InvoiceDone':
            return ['提现金额(元)','实际打款金额(元)','打款时间','申请发票时间','开具发票时间','打款卡号','开票金额','状态'];
          default: return []
        }
      },
      //切换menu时显示相应的title
      withdrawTitle() {
        let t = this.withdrawMenuArr.filter(v => v.value === this.activeName)
        return t[0] ? t[0].name : '资金提现'
      },
      invoiceTitle() {
        let t = this.invoiceMenuArr.filter(v => v.value === this.activeName)
        return t[0] ? t[0].name : '开发票'
      },
      //显示申请提现和申请开票的按钮
      showCtrolBtn() {
        return this.$GFUN.isInArray(['allowWithdraw','allowInvoice'],this.activeName)
      },
      ctrolBtnText() {
        switch (this.activeName) {
          case 'allowWithdraw': return {btn:'申请提现',cbi:'请选择银行卡',allbtn:'全部提现',backups:this.StoreBankcardList.lists};
          case 'allowInvoice': return {btn:'申请开票',cbi:'请选择开票信息',backups:this.StoreInvoiceLists.lists};
          default:return {}
        }
      },
    },
    watch:{
      currentPage(newVal) {
        let query = {...this.queryCon,page:newVal};
        this.$router.push({name:this.$route.name,query})
      },
      'queryCon.tab'(newVal) {
          this.activeName = newVal;
          this.timestamp = '';
          this.searchType = 'orderNum'
          this.searchText = '';
          this.payMerge = false
      },
      queryCon(newVal) {
        this.getLists();
      },
      //可提现列表时全选当前页
      'allChecked': 'setAllChecked'
    },
    data() {
      return {
        searchText:'',
        timestamp: '',
        currentPage:1,
        activeName:'all',
        allChecked:false,
        beginCtrol:false,
        showTenNum:true,
        searchType:'orderNum',
        storeType:3,
        chooseBackup:'',
        withdrawMenuArr:[
          {name:'可提现',value:'allowWithdraw'},
          {name:'冻结中',value:'Freezing'},
          {name:'已提现',value:'WithdrawDone'},
        ],
        invoiceMenuArr:[
          {name:'可开发票',value:'allowInvoice'},
          {name:'开票审核中',value:'verifyInvoice'},
          {name:'已开票',value:'InvoiceDone'},
        ],
        btnmsg: '查看平台发票信息',
        timer: null,
        payMerge: false
      }
    },
    created() {
      //更新当前查看的门店id
      if (this.queryCon.store) this.UPDATECURRENTSTORE({storeId:this.queryCon.store});
      this.activeName = this.$route.query.tab || 'all';
      this.currentPage = this.$route.query.page || 1;
      //判断提示按钮显示
      this.btnmsg = this.userInfo.type == 2 ? '查看发票信息' : '打款规则'
      //获取用户资金总数信息
      this.getStoreMoneyInfo();
      this.getLists();
    },
    destroyed() { 
      clearTimeout(this.timer);
      this.UPDATECURRENTSTORE({storeId:''});
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE','UPDATEMONEYLISTS']),
      ...mapActions(['getStoreMoneyInfo','getUserHead','getStoreMoneyLists','getStoreBankcardLists','storeWithdraw','getStoreInvoiceLists','storeApplyInvoice']),
      // 全选
      setAllChecked () {
        let lists = [];
        this.StoreMoneyList.lists.forEach((v,i) => lists[i] = {...v})
        lists.forEach(v => v.checked = this.allChecked);
        this.UPDATEMONEYLISTS({lists})
        if (!this.showTenNum) {
          this.timer = setTimeout(() => {
            this.applyCtrol()
          }, 500)
        }
      },
      //获取用户资金明细列表
      getLists(search,nonum) {
        if (search) { this.currentPage = 1 }
        let data = { page: this.currentPage }
        if (nonum) { data.num = ''; this.showTenNum = false}
        if (this.$GFUN.isInArray(['all','Freezing','WithdrawDone'],this.activeName)) {
          if ((this.userInfo.type == 99 || this.userInfo.type == 3) && !this.payMerge) {
            if (this.searchType !== 'checkinout') {
              this.titleArr.map(_ => this.$set(this.titleArr,2, {label:'支付时间',w:'w-15'}))
            } else {
              this.titleArr.map(_ => this.$set(this.titleArr,2, {label:'入住日期',w:'w-15'}))
            }
            if (this.searchType == 'checkinout') data.date_in = {start_time: this.startTime, end_time: this.endTime};
            if (this.searchType !== 'time' && this.searchType !== 'checkinout') this.timestamp = ''
          }
        } else {
          if (this.searchType !== 'time') this.timestamp = ''
        }
        switch (this.searchType) {
          case 'orderNum':
            data.order_no = this.searchText;
            break;
          case 'storeName':
            data.storeType = this.storeType;
            data.storeName = this.searchText;
            break;
          case 'tradeNum':
            data.trade_no = this.searchText;
            break;
        }
        switch (this.activeName) {
          case 'all':
            data = {         //资金明细
              ...data,
              adtime: {start_time: this.startTime, end_time: this.endTime},
              money: ['neq', 0],
            };
            if (this.searchType == 'time') {
              data.adtime = {start_time: this.startTime, end_time: this.endTime}
              delete data.date_in
            }
           break;
          case 'rebate':data = {         //返点明细
            ...data,
          }; break;
          case 'WithdrawDone':data = {     //已提现明细
            ...data,
            status:1,
            start_time: this.startTime,
            end_time: this.endTime,
            is_merge: this.payMerge ? '1' : ''
          }; break;
          case 'Freezing':data = {         //冻结金额
            ...data,
            status:'0',
            start_time: this.startTime,
            end_time: this.endTime,
            order_no:this.searchText
          }; break;
          case 'allowInvoice':data = {     //可开票
            ...data,
            status:'1',
            is_verify:'0'
          }; break;
          case 'verifyInvoice':data = {     //开票审核中
            ...data,
            status:'1',
            is_verify:'2'
          }; break;
          case 'InvoiceDone':data = {     //已开票
            ...data,
            status:'1',
            is_verify:'1'
          }; break;
        }
        if (this.searchType == 'checkinout') { data.adtime.start_time = ''; data.adtime.end_time = ''}
        if (this.userInfo.type === 2 && this.activeName === 'all') {
          switch (this.activeName) {
            case 'all':
              delete data.adtime;
              delete data.money;
              data = {
                ...data,
                start: this.startTime,
                end: this.endTime
              }; break;
          }
        }
        if (nonum) this.getStoreMoneyLists({flag:this.activeName, data, successFun: res => {this.allChecked = true;this.setAllChecked()}})
        else this.getStoreMoneyLists({ flag:this.activeName, data, successFun: res => {this.allChecked = false}});
      },
      //切换tab
      handleSelect(key) {
        this.currentPage = 1;
        this.activeName = key;
        this.$router.push({
          name:this.$route.name,
          query:{...this.$route.query,tab:key,page:this.currentPage}
        })
      },
      applyAllCtrol () {
        this.allChecked = false
        this.getLists('','nonum')
      },
      //发起申请提现、申请开票
      applyCtrol() {
        if (!this.$GFUN.powerIsInArray([257,203,211,323,326,411,417,570,576])) { this._alert('您没有相关权限！',null,'error'); return; }
        let lists = this.StoreMoneyList.lists.filter(v => v.checked);
        if (lists.length <= 0) { this._alert('请选择操作项',null,'error'); return }
        if (this.totalWithdraw < 10 && this.activeName === 'allowWithdraw') {
          this._alert('可提金额少于10元，无法发起提现',null,'error'); return
        }
        switch (this.activeName) {
          case 'allowWithdraw': this.getStoreBankcardLists(); break;
          case 'allowInvoice': this.getStoreInvoiceLists(); break;
          default:return ''
        }
        this.beginCtrol = true;
      },
      //添加新的银行卡和发票信息
      addNewBackup() {
        let query = {};
        if (this.isGroup) query.store = this.queryCon.store;
        switch (this.activeName) {
          case 'allowWithdraw': this.$router.push({name:'addBankcard',query}); break;
          case 'allowInvoice': this.$router.push({name:'addInvoice',query}); break;
        }
      },
      //返点提现处理中
      ComMsg () {
        if (this.userInfo.type == 2) {
          this.$alert(`<div class="mb-2 text-left"><h4>平台发票信息：</h4><p>公司抬头：杭州订单雨络科技有限公司</p>
            <p>公司税号：91330103MA27X0EC4Y</p>
            <p>发票类型：普通</p></div>
            <div class="text-left"><h4>邮寄地址：</h4><p>收件人：财务部</p><p>电话：0571-87297251</p>
            <p>公司地址：浙江省杭州市上城区江城路887号联银大厦西楼1007-1008室</p></div>`, '平台发票信息', {
            confirmButtonText: '确定',
            type: 'warning',
            center: true,
            dangerouslyUseHTMLString: true
          })
        } else {
          this.$alert(`
                <div class="mb-2 text-left">工作日内16:30之前申请的提现，当天可以操作打款（除特殊情况外），
                工作日内16:30之后申请的提现，下个工作日操作打款。</div>`, '打款规则', {
            confirmButtonText: '确定',
            type: 'warning',
            center: true,
            dangerouslyUseHTMLString: true
          })
        }
      },
      cancelCtrol () {
        this.beginCtrol = false
        if (!this.showTenNum) {
          this.showTenNum = true;
          this.getLists()
        }
      },
      //确认提现、确认开票
      ensureCtrol() {
        if (this.activeName == 'allowWithdraw' && !this.chooseBackup) {
          if (this.ctrolBtnText.backups.length == 1) this.chooseBackup = this.ctrolBtnText.backups[0].id
          else {
            let defaultarr = this.ctrolBtnText.backups.filter(v => v.is_default)
            if (defaultarr.length > 0) this.chooseBackup = defaultarr[0].id
          }
        }
        if (!this.chooseBackup) { this._alert(this.ctrolBtnText.cbi,null,'error'); return }
        switch (this.activeName) {
          case 'allowWithdraw':
            let data = {};
            if (this.userInfo.type === 2) data = {
              bank:this.chooseBackup,
              id:this.StoreMoneyList.lists.map(v => { if (v.checked) return v.id })
            }
            else data = {
              bankcard_id:this.chooseBackup,
              son_data:this.StoreMoneyList.lists.map(v => { if (v.checked) return {oid:v.oid} })
            }
            this.storeWithdraw({
              data,
              successFun: () => {
                this.beginCtrol = false;
                if (this.userInfo.type == 2) {
                  this.$alert(`<p class="mb-2 text-left text-red">提现申请已提交、请您及时邮寄返点金额的发票到本平台，待本台收到发票后，才能处理您的提现申请。感谢您的理解与支持。</p>
                    <div class="mb-2 text-left"><h4>平台发票信息：</h4><p>公司抬头：杭州订单雨络科技有限公司</p>
                    <p>公司税号：91330103MA27X0EC4Y</p>
                    <p>发票类型：普通</p></div>
                    <div class="text-left"><h4>邮寄地址：</h4><p>收件人：财务部</p><p>电话：0571-87297251</p>
                    <p>公司地址：浙江省杭州市上城区江城路887号联银大厦西楼1007-1008室</p></div>`, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                    center: true,
                    dangerouslyUseHTMLString: true
                  }).then(() => {
                    this.getStoreMoneyInfo();
                    this.getUserHead();
                    this.getLists();
                  });
                } else {
                  this.$alert(`<p class="mb-2">提现申请已提交，请等待平台打款处理！</p>
                              <div class="mb-2 text-left"><h4>提现规则说明：</h4><p class="text-red">工作日内16:30之前申请的提现，当天可以操作打款（除特殊情况外），
                              工作日内16:30之后申请的提现，下个工作日操作打款。</p></div>`,'提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                    center: true,
                    dangerouslyUseHTMLString: true
                  }).then(() => { 
                    this.getStoreMoneyInfo();
                    this.getUserHead();
                    this.getLists();
                  })
                }
              }
          }); break;
          case 'allowInvoice':
            let chooseLists = this.StoreMoneyList.lists.filter(v => v.checked);
            let total = chooseLists.reduce((total,item) => { return total + (Number(item.money) - Number(item.money_end)) },0);
            let ids = chooseLists.map(v => v.id);
            this.storeApplyInvoice({
              data:{
                invoice_id:this.chooseBackup,
                money:(total / 100).toFixed(2),
                withdraw_ids:ids.join(',')
              },
              successFun: () => {
                this.beginCtrol = false;
                this._alert('发票申请成功，请等待管理员审核',() => { 
                  this.getStoreMoneyInfo();
                  this.getUserHead();
                  this.getLists();
                })
              }
          }); break;
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.defaultbg {
  border-color: #10c568;
  background: #ebfcf3
}
.single-choose{
  height: auto
}
</style>
